"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const HelperUtils_1 = require("utils/HelperUtils");
const ContentTabSwitcher = ({ tabs, defaultTabIndex = 0, onChange = () => null, customContainerClass = '' }) => {
    const [currentTab, setCurrentTab] = (0, react_1.useState)('');
    const tabsContainerCN = (0, classnames_template_literals_1.default)(`
    flex
    w-min
    bg-n-300
    rounded-[4px]
    p-[4px]
    ${customContainerClass}
  `);
    const tabCN = (tabId, index) => {
        return (0, classnames_template_literals_1.default)(`
        ${tabId === currentTab ? 'bg-n-000 rounded-[4px]' : ''}
        ${index === 0 ? '' : 'ml-[16px]'}
        px-[16px]
        py-[8px]
        hover:cursor-pointer
      `);
    };
    const tabTextCN = (tabId) => {
        return (0, classnames_template_literals_1.default)(`
        ${tabId === currentTab ? 'text-n-900' : 'text-n-600'}
        typography-button
        whitespace-nowrap
      `);
    };
    const handleClickTab = (tabId) => {
        setCurrentTab(tabId);
        onChange(tabId);
    };
    (0, react_1.useEffect)(() => {
        setCurrentTab(tabs[defaultTabIndex]?.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultTabIndex]);
    return (react_1.default.createElement("div", { className: tabsContainerCN }, tabs.map((tab, index) => (react_1.default.createElement("div", { className: tabCN(tab?.id, index), onClick: () => handleClickTab(tab?.id), key: index },
        react_1.default.createElement("p", { className: tabTextCN(tab?.id), "data-cy": tab?.dataCy || tab?.id }, (0, HelperUtils_1.getObjectiveLocale)(tab?.name)))))));
};
exports.default = ContentTabSwitcher;
